export default __webpack_public_path__ + "2eeb30ebc5bee9ac3d42297cebca9a40.ttf";